import {observer} from "mobx-react";
import {ActionDto} from "../../stores/models/qarFormModels";
import React from "react";
import {EmployeeReviewActions} from "../../stores/models/enums";
import {Checkbox} from "@material-ui/core";
import {useStores} from "../../stores/rootStore";
import QARFormHelper from "./helper";

export const QARFormAccountBulkReview = observer(({ action, actionChanges }: { action: ActionDto, actionChanges: ActionDto }) => {

    const {qarFormStore} = useStores();

    const accountBulkReviewChecked = (actionChanges: ActionDto) => {
        return actionChanges.name === EmployeeReviewActions.Approved;
    }

    const bulkReviewsCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.checked) {
            actionChanges.name = EmployeeReviewActions.Approved;
        } else {
            actionChanges.name = EmployeeReviewActions.MissingAction;            
        }

        qarFormStore.setBulkReviewsIndeterminate();
    }

    const renderBulkAccountReviewCheckbox = () => {
        return (
            <Checkbox
                disabled={QARFormHelper.accountBulkReviewDisabled(action, actionChanges)}
                checked={accountBulkReviewChecked(actionChanges)}
                onChange={(e) => bulkReviewsCheckboxChange(e)}                
                inputProps={{ 'aria-label': 'secondary checkbox' }}
                color={"primary"}
            />
        );
    }

    if(qarFormStore.shouldDisplayBulkReview){
        return (
            <>
                {renderBulkAccountReviewCheckbox()}
            </>
        );
    }

    return <></>;
});